export default [
    {
        type: "uni",
        id: 1,
        items: [
            {
                id: 1,
                text: "Der Dozent/Die Dozentin war engagiert und motiviert.",
            },
            {
                id: 2,
                text: "Der Dozent/Die Dozentin hat die Inhalte angemessen wiederholt.",
            },
            {
                id: 3,
                text: "Ich konnte dem Tempo des Dozenten/der Dozentin gut folgen.",
            },
            {
                id: 4,
                text: "Der Dozent/Die Dozentin ermöglichte eine gute Lern- und Arbeitsatmosphäre.",
            },
            {
                id: 5,
                text: "Der Dozent/Die Dozentin gab die Möglichkeit, Themen zu diskutieren.",
            },
            {
                id: 6,
                text: "Der Dozent/Die Dozentin war stets gut vorbereitet.",
            },
            {
                id: 7,
                text: "Der Dozent/Die Dozentin war fachlich kompetent.",
            },
            {
                id: 8,
                text: "Der Dozent/Die Dozentin konnte Kompliziertes verständlich machen.",
            },
            {
                id: 9,
                text: "Dem Dozenten/Der Dozentin war es wichtig, dass die Teilnehmer/innen etwas lernen.",
            },
            {
                id: 10,
                text: "Der Dozent/Die Dozentin motivierte die Teilnehmer/innen.",
            },
            {
                id: 11,
                text: "Der Dozent/Die Dozentin hat aufkommende Fragen gut beantwortet.",
            },
            {
                id: 12,
                text: "Der Dozent/Die Dozentin hat auf die Beiträge der Teilnehmer/innen ein hilfreiches Feedback gegeben.",
            },
            {
                id: 13,
                text: "Das Betreuungsangebot des Dozenten/der Dozentin (z.B. im Rahmen von Sprechstunden) war ausreichend.",
            },
            {
                id: 14,
                text: "Der Dozent/Die Dozentin motiviert die Teilnehmer/innen mitzudenken.",
            },
            {
                id: 15,
                text: "Der Dozent/Die Dozentin war im Umgang mit den Teilnehmern/innen fair.",
            },
            {
                id: 16,
                text: "Der Dozent/Die Dozentin hat Dialektik/Argumente/Aufbau/Struktur der behandelten Textgrundlagen deutlich gemacht.",
            },
            {
                id: 17,
                text: "Das Lernziel wurde mir deutlich.",
            },
            {
                id: 18,
                text: "Die angestrebten Lernziele wurden von vorneherein gut definiert.",
            },
            {
                id: 19,
                text: "Die Veranstaltung war übersichtlich und verständlich.",
            },
            {
                id: 20,
                text: "Der inhaltliche Aufbau der Veranstaltung war logisch/nachvollziehbar.",
            },
            {
                id: 21,
                text: "Das Format des Seminars (z.B. Referate, Lektüre, Hausaufgaben) war sinnvoll.",
            },
            {
                id: 22,
                text: "Argumentrekonstruktionen waren Bestandteil der Veranstaltung.",
            },
            {
                id: 23,
                text: "Argumentrekonstruktionen wurden sinnvoll und nachvollziehbar eingesetzt.",
            },
            {
                id: 24,
                text: "Das Thema der Veranstaltung ist im Fachkontext relevant.",
            },
            {
                id: 25,
                text: "Die ausgewählte Literatur zum Thema der Veranstaltung war interessant.",
            },
            {
                id: 26,
                text: "Ich habe das Gefühl, in der Veranstaltung etwas für das Fach Wichtiges gelernt zu haben.",
            },
            {
                id: 27,
                text: "Das behandelte Thema enthält Bezüge zu meiner späteren Berufstätigkeit.",
            },
        ],
    },
    {
        type: "bi",
        id: 2,
        items: [
            {
                id: 28,
                text: "Die Schwierigkeit des Stoffes war...",
            },
            {
                id: 29,
                text: "Dialektik/Argumente/Aufbau/Struktur der behandelten Textgrundlagen war...",
            },
            {
                id: 30,
                text: "Der Umfang des Stoffes war...",
            },
            {
                id: 31,
                text: "Die Ansprüche an das vorausgesetzte Vorwissen waren...",
            },
            {
                id: 32,
                text: "Das Tempo der Veranstaltung war...",
            },
            {
                id: 33,
                text: "Die Anforderungen der Veranstaltung waren...",
            },
            {
                id: 34,
                text: "Die formalen/logischen Aspekte der Veranstaltung empfand ich als...",
            },
            {
                id: 35,
                text: "Der Zeitaufwand für die Veranstaltung insgesamt (inkl. Vor- und Nachbereitung) war...",
            },
            {
                id: 36,
                text: "Insgesamt empfand ich die Veranstaltung als...",
            },
        ],
    },
    {
        type: "uni",
        id: 3,
        items: [
            {
                id: 37,
                text: "Insgesamt fand ich die Veranstaltung gut.",
            },
            {
                id: 38,
                text: "In der Veranstaltung habe ich viel gelernt.",
            },
            {
                id: 39,
                text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
            },
            {
                id: 40,
                text: "Ich würde die Veranstaltung weiterempfehlen.",
            },
        ],
    },
    {
        type: "text",
        id: 4,
        items: [
            {
                id: 41,
                text: "Besonders gut oder störend fand ich:",
            },
            {
                id: 42,
                text: "Wenn ich mich nicht beteiligt habe, dann hatte das folgende Gründe:",
            },
            {
                id: 43,
                text: "Verbesserungsvorschläge:",
            },
        ],
    },
    {
        type: "special",
        id: 5,
        items: [
            {
                id: 44,
                text: "Studiengang:",
                label: [
                    {
                        id: 1,
                        text: "Bachelor",
                    },
                    {
                        id: 2,
                        text: "Master",
                    },
                    {
                        id: 3,
                        text: "Lehramt",
                    },
                ],
            },
        ],
    },
    {
        type: "text",
        id: 6,
        title: "Persönliche Angaben",
        items: [
            {
                id: 45,
                type: "small",
                text: "Fachsemester: ",
            },
        ],
    },
];